import { jsx as _jsx } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgXShare = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "#2D2E31",
    d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.522 2 12 2m1.654 15.245-2.59-3.619-3.384 3.62H6.144l4.253-4.55-4.253-5.942h4.202l2.432 3.397 3.175-3.397h1.536l-4.046 4.327 4.413 6.164zm-3.88-9.378 5.917 8.265h-1.465L8.31 7.867z"
  })
});
export default SvgXShare;